import React from 'react';
import FormNuevoPlan from '../FormNuevoPlan';
import { Row, Col, Alert } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import CardPlan from '../CardPlan';
import FormPlanMensualidades from '../FormPlanMensualidades';
import HeaderSeccionModalidad from '../HeaderSeccionModalidad';
import { faListAlt } from '@fortawesome/free-solid-svg-icons';

const PlanesMensualidades = ({ onShowModal, onCloseModal, handleEliminarPlan }) => {
  const { planPagosMensualidades = [] } = useSelector(state => state.cursos.proyecto.planes) || [];

  const handleClick = () => {
    onShowModal(<FormNuevoPlan 
      onCloseModal={onCloseModal}
      idTipoModalidad={1}
    />, 'Nuevo plan');
  }

  const handleEditar = (plan) => {
    onShowModal(<FormNuevoPlan
      onCloseModal={onCloseModal}
      idTipoModalidad={1}
      plan={plan}
    />, 'Editar plan');
  }

  const handleCLickExaminarPlan = (plan) => {
    onShowModal(<FormPlanMensualidades
      onCloseModal={onCloseModal}
      plan={plan}
    />, 'Examinar plan');
  }

  const handleEliminar = (idPlan) => {
    handleEliminarPlan(1, idPlan)
  }

  const handleMostrarPlanes = () => {
    if(planPagosMensualidades && planPagosMensualidades.length > 0) {
      return [...planPagosMensualidades].map(plan => (
        <Col lg={2} md={3} sm={6} key={plan.id_plan}>
          <CardPlan
            plan={plan}
            handleExaminar={handleCLickExaminarPlan}
            handleEliminar={handleEliminar}
            handleEditar={handleEditar}
          />
        </Col>
      ))
    }
    return <Col sm={12}>
      <Alert variant='info'>
        No hay planes registrados 
      </Alert>
    </Col>
  }

  return ( 
    <div className="PlanesMensualidades">
      <div className="PlanesMensualidades__accion-boton text-right">
        <HeaderSeccionModalidad
          title='MENSUALIDADES'
          icon={faListAlt}
          handleClick={handleClick}
        />
      </div>
      <div className="PlanesMensualidades__lista">
        <Row>
          {handleMostrarPlanes()}
        </Row>
      </div>
    </div>
  );
}
 
export default PlanesMensualidades;